module.exports = __webpack_public_path__ + "static/media/linkedin-logo.cbeb6285.svg";